/* Blessed Choice — bc-desc-img v1 (21/09/2026)
   Corrige o peso das imagens dentro da descrição do produto.

   Problema: as descrições embutem fotos direto de cdn.shopify.com/s/files/ na
   resolução original (1500px, 350-630 KB cada; tabelas de medidas chegam a 1 MB).
   No celular a imagem ocupa 295px — baixar 1500px é ~2,5x mais pixel do que a
   tela mostra. Medido: 969 KB por página de produto só nisso.

   O que faz: acrescenta srcset (600/800/1000/1500) + sizes nas imagens da
   descrição que ainda não tenham. O navegador passa a escolher 600px no celular
   comum, 1000px em tela 3x e 1500px no desktop retina — sem perda de nitidez.
   Medido no produto piloto: 969 KB -> 161 KB (-84%).

   Por que no tema e não na descrição de cada produto: são 3.478 produtos
   afetados e a API de escrita em lote está bloqueada. Aqui resolve todos de uma
   vez, inclusive os que forem cadastrados daqui pra frente.

   Seguro por construção:
   - só toca <img> cujo src é do cdn.shopify.com/s/files/
   - pula quem já tem width= na URL ou já tem srcset (não conflita com os
     produtos já corrigidos na mão)
   - só dentro da descrição do produto, nunca na galeria
   - roda antes das imagens entrarem em tela (elas são loading="lazy"), então
     não há download duplicado
   - se algo falhar, as imagens seguem carregando como hoje (sem regressão)
*/
(function () {
  'use strict';

  var LARGURAS = [600, 800, 1000, 1500];
  var SIZES = '(min-width: 750px) 700px, 80vw';
  var CDN = 'cdn.shopify.com/s/files/';

  /* onde a descrição do produto vive neste tema */
  var SELETORES = [
    '.bcl',
    '.product-block-list__item--description',
    '[data-bc-frio-story]',
    '.product-single__description'
  ];

  function corrigir(img) {
    var src = img.getAttribute('src') || '';
    if (src.indexOf(CDN) === -1) return false;
    if (src.indexOf('width=') > -1) return false;
    if (img.getAttribute('srcset')) return false;

    var sep = src.indexOf('?') > -1 ? '&' : '?';
    var partes = [];
    for (var i = 0; i < LARGURAS.length; i++) {
      partes.push(src + sep + 'width=' + LARGURAS[i] + ' ' + LARGURAS[i] + 'w');
    }
    img.setAttribute('srcset', partes.join(', '));
    img.setAttribute('sizes', SIZES);
    /* fallback para navegador sem srcset; 1000 cobre até tela 3x */
    img.setAttribute('src', src + sep + 'width=1000');
    if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
    if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    return true;
  }

  function rodar() {
    var n = 0;
    for (var s = 0; s < SELETORES.length; s++) {
      var caixas = document.querySelectorAll(SELETORES[s]);
      for (var c = 0; c < caixas.length; c++) {
        var imgs = caixas[c].querySelectorAll('img');
        for (var i = 0; i < imgs.length; i++) {
          try { if (corrigir(imgs[i])) n++; } catch (e) {}
        }
      }
    }
    if (n && window.dataLayer) {
      try { window.dataLayer.push({ event: 'bc_desc_img', corrigidas: n }); } catch (e) {}
    }
    return n;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rodar);
  } else {
    rodar();
  }

  /* descrições que aparecem depois (abas, acordeão, quick view) */
  if (window.MutationObserver && document.body) {
    var pendente = null;
    new MutationObserver(function () {
      clearTimeout(pendente);
      pendente = setTimeout(rodar, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();